import { render, staticRenderFns } from "./CanalDeVendasGrid.vue?vue&type=template&id=4eb07ba4&scoped=true&"
import script from "./CanalDeVendasGrid.vue?vue&type=script&lang=ts&"
export * from "./CanalDeVendasGrid.vue?vue&type=script&lang=ts&"
import style0 from "./CanalDeVendasGrid.vue?vue&type=style&index=0&id=4eb07ba4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb07ba4",
  null
  
)

export default component.exports